import store from "../../../store/store"
import {MessageBox} from 'element-ui'
import config from '../config'
export default {
	img(url){
		if(!url){
			return ''
		}
		if(url.indexOf('http') >= 0){
			return url
		}
		if(url){
			return config.imageUrl + url;
		}
		return '';
	},
	cloneObj(obj){
		return JSON.parse(JSON.stringify(obj));
	},
	generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },
	checkPermission(permission){
		return true;
        let routers = store.getters['admin/routers'];
        if(routers.indexOf(permission) >= 0){
        	return true;
        }
        return false;
	},
	cacheSet(key, value){
		localStorage.setItem(key, value);
	},
	cacheGet(key){
		return localStorage.getItem(key);
	},
	showImage(image) {
		MessageBox.alert('<img src="'+ image +'" style="width: 100%" />', {
			dangerouslyUseHTMLString: true
		});
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/util/util.js